import React from 'react';

import { getDoctorChatTicketLabel, lang, number, remCss, withRouter } from 'src/helpers';
import CertificateDetail from 'src/components/user/CertificateDetail';
import LANG_CONST from 'src/helpers/lang/const';
import { View } from 'src/components/basic';

class CenterDetail extends React.PureComponent {
  render() {
    const doctor = this.props.detail || this.props;
    if (!doctor.id) return null;
    let { booked } = this.props;
    const chatTicketLabel = getDoctorChatTicketLabel(doctor.charge?.chatTicket, doctor.currency);
    // console.warn('CenterDetail', doctor);
    return (
      <div className={'mc-content-center '}>
        {booked && (
          <div className={'mc-box'}>
            <div className={'mc-title'}>Booked</div>
          </div>
        )}
        <pre style={{ marginTop: 0, whiteSpace: 'break-spaces' }} className={'mc-description'}>
          {doctor.description}
        </pre>
        <div className={'mc-box'}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.titles.qualifications)}</div>
          <div className={'mc-flex'}>
            <div className={'mc-label'}>{lang.t(LANG_CONST.doctor_type)}</div>
            <div className={'mc-value'}>
              {lang.t(LANG_CONST.constants.doctor_types[doctor.doctorType])}
            </div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label'}>{lang.t(LANG_CONST.institution)}</div>
            <div className={'mc-value'}>{doctor.institution}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label'}>{lang.t(LANG_CONST.gender)}</div>
            <div className={'mc-value'}>{lang.t(LANG_CONST.constants.gender[doctor.gender])}</div>
          </div>
          <div className={'mc-flex'}>
            <div className={'mc-label'}>{lang.t(LANG_CONST.year_of_starting)}</div>
            <div className={'mc-value'}>{doctor.yearOfStarting}</div>
          </div>
        </div>
        {doctor.treatments?.length > 0 && (
          <div className={'mc-box'}>
            <div className={'mc-title'}>{lang.t(LANG_CONST.titles.treatments)}</div>
            {doctor.treatments.map((item, i) => (
              <div className={'mc-flex'} key={i}>
                <div className={'mc-label'}>{item.name || item.title}</div>
                <div className={'mc-value'}>
                  {item.fee || item.amount} {doctor.currency}
                </div>
              </div>
            ))}
          </div>
        )}
        <View className={'mc-box'} style={{ gap: remCss(20) }}>
          <div className={'mc-title'}>{lang.t(LANG_CONST.consultant_charges)}</div>
          <div className={'mc-value-720'}>{lang.t(LANG_CONST.first_consultation)}</div>
          {doctor.charge?.first && (
            <>
              <div className={'mc-flex'}>
                <div className={'mc-value-418 mc-grow'}>
                  {lang.t(LANG_CONST.constants.appointment_types.virtual)}
                </div>
                <div className={'mc-label-418'}>
                  {number.format(doctor.charge?.first.virtual)} {doctor.currency}
                </div>
              </div>
              <div className={'mc-flex'}>
                <div className={'mc-value-418 mc-grow'}>
                  {lang.t(LANG_CONST.constants.appointment_types.in_office)}
                </div>
                <div className={'mc-label-418'}>
                  {number.format(doctor.charge?.first.office)} {doctor.currency}
                </div>
              </div>
            </>
          )}
          <div className={'mc-value-720'}>
            {lang.t(LANG_CONST.text.follow_up, { attr: doctor.followupDuration || 30 })}
          </div>
          {doctor.charge?.followup && (
            <>
              <div className={'mc-flex'}>
                <div className={'mc-value-418 mc-grow'}>
                  {lang.t(LANG_CONST.constants.appointment_types.virtual)}
                </div>
                <div className={'mc-label-418'}>
                  {number.format(doctor.charge?.followup.virtual)} {doctor.currency}
                </div>
              </div>
              <div className={'mc-flex'}>
                <div className={'mc-value-418 mc-grow'}>
                  {lang.t(LANG_CONST.constants.appointment_types.in_office)}
                </div>
                <div className={'mc-label-418'}>
                  {number.format(doctor.charge?.followup.office)} {doctor.currency}
                </div>
              </div>
            </>
          )}
          {chatTicketLabel && (
            <div className={'mc-flex mc-wrap'}>
              <div className={'mc-value-720 mc-grow'}>{lang.t(LANG_CONST.chat_ticket)}</div>
              <div className={'mc-label-418'}>{chatTicketLabel}</div>
            </div>
          )}
        </View>
        {doctor.certificateFiles?.length > 0 && (
          <View className={'mc-box'} style={{ gap: remCss(20) }}>
            <div className={'mc-title'}>{lang.t(LANG_CONST.titles.certificates)}</div>
            <View style={{ gap: remCss(15) }}>
              {doctor.certificateFiles?.map((item, i) => (
                <CertificateDetail item={item} key={i} />
              ))}
            </View>
          </View>
        )}
      </div>
    );
  }
}

export default withRouter(CenterDetail);
